import { useState } from 'react';
import { ErroApi } from '../lib/api';
import { criarContaDeMembro } from '../lib/escalas';
import { gerarSenha } from '../lib/senha';
import { Alerta, Botao, Campo, Modal } from './Interface';

/**
 * Da conta a uma ficha que ja existe. Aberto de dois lugares — o candidato sem
 * conta na lista e a fila de pendencias — e sempre apontando para a ficha, nunca
 * criando uma pessoa nova.
 */
export default function ModalConta({
  pessoa,
  ministerio,
  aoFechar,
  aoCriar,
  criar,
}: {
  pessoa: { id: number; nome: string };
  /** quem cria a conta; a escala de lideres usa a rota que da papel de lider */
  criar?: (dados: { email: string; senha: string }) => Promise<unknown>;
  /** ministerio em que a pessoa entra junto; a escala de lideres nao manda nenhum */
  ministerio?: string;
  aoFechar: () => void;
  aoCriar: (senha: string) => void;
}) {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState(() => gerarSenha());
  const [erro, setErro] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);

  async function salvar() {
    if (!email.trim()) {
      setErro('Informe o e-mail: e por ele que a pessoa entra.');
      return;
    }
    if (senha.length < 8) {
      setErro('A senha precisa de pelo menos 8 caracteres.');
      return;
    }
    setOcupado(true);
    setErro(null);
    try {
      if (criar) {
        await criar({ email: email.trim(), senha });
      } else {
        await criarContaDeMembro(pessoa.id, {
          email: email.trim(),
          senha,
          ...(ministerio ? { ministerios: [ministerio] } : {}),
        });
      }
      aoCriar(senha);
    } catch (e) {
      setErro(e instanceof ErroApi ? e.message : 'Não consegui criar a conta.');
    } finally {
      setOcupado(false);
    }
  }

  return (
    <Modal aoFechar={aoFechar} titulo={`Criar conta de ${pessoa.nome}`}>
      {erro && <Alerta>{erro}</Alerta>}
      <div className="mt-3 space-y-3">
        <Campo
          rotulo="E-mail"
          type="email"
          value={email}
          onChange={(ev) => setEmail(ev.target.value)}
        />
        <Campo
          rotulo="Senha inicial"
          type="text"
          value={senha}
          onChange={(ev) => setSenha(ev.target.value)}
        />
        <button
          type="button"
          onClick={() => setSenha(gerarSenha())}
          className="text-xs text-tinta-400 underline hover:text-tinta-900"
        >
          gerar senha
        </button>
        <p className="text-xs text-tinta-400">
          A ficha de {pessoa.nome} continua a mesma — a conta so liga o acesso a ela.
        </p>
      </div>
      <div className="mt-5 flex justify-end gap-2">
        <Botao variante="secundario" onClick={aoFechar}>
          Cancelar
        </Botao>
        <Botao onClick={salvar} carregando={ocupado}>
          Criar conta
        </Botao>
      </div>
    </Modal>
  );
}
